import React, { useState } from 'react';
import { experience } from '../data/mock';
import { MapPin, Calendar, ChevronLeft, ChevronRight } from 'lucide-react';
import '../styles/Experience.css';

const Experience = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState({});

  const handleNextImage = (expId, imagesLength) => {
    setCurrentImageIndex(prev => ({
      ...prev,
      [expId]: ((prev[expId] || 0) + 1) % imagesLength
    }));
  };

  const handlePrevImage = (expId, imagesLength) => {
    setCurrentImageIndex(prev => ({
      ...prev,
      [expId]: ((prev[expId] || 0) - 1 + imagesLength) % imagesLength
    }));
  };

  return (
    <section className="experience-section" id="experience">
      <div className="experience-container">
        <h2 className="section-title">Experience</h2>
        
        <div className="experience-timeline">
          {experience.map((exp, index) => (
            <div key={exp.id} className="experience-card">
              {exp.images && exp.images.length > 0 && (
                <div className="experience-image-wrapper">
                  <img 
                    src={exp.images[currentImageIndex[exp.id] || 0]} 
                    alt={exp.title}
                    className="experience-image"
                  />
                  {exp.images.length > 1 && (
                    <>
                      <button 
                        className="exp-image-nav-btn prev"
                        onClick={() => handlePrevImage(exp.id, exp.images.length)}
                        aria-label="Previous image"
                      >
                        <ChevronLeft size={24} />
                      </button>
                      <button 
                        className="exp-image-nav-btn next"
                        onClick={() => handleNextImage(exp.id, exp.images.length)}
                        aria-label="Next image"
                      >
                        <ChevronRight size={24} />
                      </button>
                      <div className="exp-image-indicators">
                        {exp.images.map((_, idx) => (
                          <span 
                            key={idx} 
                            className={`exp-indicator ${idx === (currentImageIndex[exp.id] || 0) ? 'active' : ''}`}
                            onClick={() => setCurrentImageIndex(prev => ({ ...prev, [exp.id]: idx }))}
                          />
                        ))}
                      </div>
                    </>
                  )}
                </div>
              )}
              
              <div className="experience-header">
                <div>
                  <h3 className="experience-title">{exp.title}</h3>
                  <p className="experience-company">{exp.company}</p>
                </div>
                <div className="experience-meta">
                  <div className="meta-item">
                    <Calendar size={16} />
                    <span>{exp.period}</span>
                  </div>
                  <div className="meta-item">
                    <MapPin size={16} />
                    <span>{exp.location}</span>
                  </div>
                </div>
              </div>
              
              <ul className="experience-list">
                {exp.description.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;